<template>
    <a @click="toggleStatus">
        {{ this.status === this.referenceStatus ? this.enabledStatusLabel : this.disabledStatusLabel }}
    </a>
</template>

<script>
    export default {
        name: 'ToggleStatusButton',
        mounted() {
            this.handler(this.subscription, this.initialStatus);
        },
        props: {
            subscription: String,
            initialStatus: String,
            referenceStatus: String,
            enabledStatusLabel: String,
            disabledStatusLabel: String,
            route: String,
            handler: Function,
            status: String
        },
        methods: {
            toggleStatus () {
                if (this.route) {
                    axios.post(this.route, {
                        'item' : this.subscription
                    }).then(response => {
                        this.handler(this.subscription, response.data.current_status);
                    }).catch(function (error) {
                        console.log(error);
                    });
                }
            }
        },
    }
</script>

<style scoped>

</style>